import moment from 'moment'
import { OfferedShipment } from 'apps/fleet-planner/types'

const getBidExpiredAtInMinutes = (expiredAt: number) => {
  return Math.round(moment.duration(expiredAt, 'seconds').asMinutes())
}

export const getOfferStatusMessage = (offer: OfferedShipment): string => {
  const { acceptedBidExpiredAt = 0, offeredState, waterfallTimeLeftMinutes } = offer || {}
  switch (offeredState) {
    case 'bid_accepted':
      return acceptedBidExpiredAt
        ? `Bid accepted offer expires in ${getBidExpiredAtInMinutes(acceptedBidExpiredAt)} min`
        : 'Bid expires soon'
    case 'dedicated_rate_current_tier_carrier':
      return waterfallTimeLeftMinutes
        ? `This load will be offered to more carriers in ${waterfallTimeLeftMinutes} min`
        : 'Other carriers are seeing this load. Book soon!'
    case 'dedicated_rate_offered_to_more_carriers':
      return waterfallTimeLeftMinutes
        ? `This load will be offered to more carriers in ${waterfallTimeLeftMinutes} min`
        : 'Other carriers are seeing this load. Book soon!'
    default:
      return acceptedBidExpiredAt
        ? `Offer expires in ${getBidExpiredAtInMinutes(acceptedBidExpiredAt)} min`
        : 'Offer expires soon'
  }
}

export const getOfferStatus = (offer: OfferedShipment) => {
  const { offeredState } = offer || {}
  switch (offeredState) {
    case 'bid_accepted':
      return 'Bid Accepted'
    case 'dedicated_rate_current_tier_carrier':
      return 'Dedicated Rate'
    case 'dedicated_rate_offered_to_more_carriers':
      return 'Dedicated Rate'
    default:
      return 'Transfix Offer'
  }
}

export const findOfferByRouteId = (
  id: string = '',
  offers: OfferedShipment[] = []
): OfferedShipment | undefined => {
  const offer = offers.find(offer => offer?.externalId === parseInt(id, 10))
  return offer
}

export const isOfferADedicatedRateOfferedToMoreCarriers = (
  offer: OfferedShipment | undefined
): boolean => {
  const { offeredState } = offer || {}
  return offeredState === 'dedicated_rate_offered_to_more_carriers'
}
